module.exports = __webpack_public_path__ + "static/10-a84546facb568d6f3c0f0cc959db15e0.jpg";